// removed by extract-text-webpack-plugin
module.exports = {"CashTransfer1":"CashTransfer1","TabTable":"TabTable","NavTab":"NavTab","TabContent":"TabContent","fade":"fade","tab-pane":"tab-pane","active":"active","show":"show","CashTransferContent":"CashTransferContent","_53Ji7":"_53Ji7","_1Lo2h":"_1Lo2h","_2Jtxm":"_2Jtxm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/areas/Account/CashTransfer1/styles.scss
// module id = 482
// module chunks = 10